import { type FC } from 'react'

import { AccordionDetails } from 'base-ui'

import { type FooterMenuCategory } from '../../../../config/PerTenantFooterConfiguration.type'
import { FooterLinkCategory } from '../../FooterLinkCategory'
import { FooterBannerSectionAccordion } from '../FooterBannerSectionAccordion'
import { FooterBannerSectionHeader } from '../FooterBannerSectionHeader'

type FooterInfoSectionProps = {
  category: FooterMenuCategory
  className?: string
}

export const FooterInfoSection: FC<FooterInfoSectionProps> = ({
  category,
  className,
}) => (
  <FooterBannerSectionAccordion
    className={className}
    id={category.title.replaceAll(' ', '_')}
  >
    <FooterBannerSectionHeader headerText={category.title} />
    <AccordionDetails>
      <FooterLinkCategory category={category} noTitle />
    </AccordionDetails>
  </FooterBannerSectionAccordion>
)
